import React, { useEffect } from "react";
import HappyClients from "../components/common/HappyClients";
import HowItWorks from "../components/home/HowItWorks";
import Hero from "../components/home/Hero";
import BestOffers from "../components/home/BestOffers";
import BookYourTickets from "../components/home/BookYourTickets";
import PopularDestinations from "../components/home/PopularDestinations";
import Services from "../components/home/Services";
import GetTheBestTravelDeal from "../components/common/GetTheBestTravelDeal";

const Homepage = () => {
   useEffect(() => {
        document.getElementById("title-page").innerHTML = "Tripnext | Home";
      }, []);
  return (
    <div>
      <Hero />
      <HowItWorks />
      <Services />
      <PopularDestinations />
      <BookYourTickets />
      <HappyClients />
      <BestOffers />
      <GetTheBestTravelDeal />
    </div>
  );
};

export default Homepage;
